import {
    Store,
    Phone,
    Mail,
    MapPin,
    BadgeCheck,
    Package,
    IndianRupee,
    ShoppingBag,
} from "lucide-react";

import "./ProviderTab.css";

function ProviderTab({ order }) {

    const provider = order.providerSnapshot || {};

    return (

        <div className="provider-tab">

            {/* ================= Business Profile ================= */}

            <div className="provider-profile-card">

                <div className="provider-avatar">

                    <Store size={38} />

                </div>

                <div className="provider-profile-info">

                    <h2>

                        {provider.businessName || "Business"}

                    </h2>

                    <p>

                        HomeFoods Business Partner

                    </p>

                </div>

            </div>

            {/* ================= Business Details ================= */}

            <div className="provider-info-grid">

                <div className="provider-info-card">

                    <Phone size={20} />

                    <div>

                        <label>Phone</label>

                        <h4>

                            {provider.phone || "-"}

                        </h4>

                    </div>

                </div>

                <div className="provider-info-card">

                    <Mail size={20} />

                    <div>

                        <label>Email</label>

                        <h4>

                            {provider.email || "-"}

                        </h4>

                    </div>

                </div>

                <div className="provider-info-card">

                    <MapPin size={20} />

                    <div>

                        <label>Business Address</label>

                        <h4>

                            {provider.address || "-"}

                        </h4>

                    </div>

                </div>

                <div className="provider-info-card">

                    <BadgeCheck size={20} />

                    <div>

                        <label>Partner Status</label>

                        <h4>

                            Active Partner

                        </h4>

                    </div>

                </div>

            </div>

            {/* ================= Order Statistics ================= */}

            <div className="provider-stats-grid">

                <div className="provider-stat-card">

                    <ShoppingBag size={24} />

                    <div>

                        <span>

                            Order Number

                        </span>

                        <h3>

                            {order.orderNumber}

                        </h3>

                    </div>

                </div>

                <div className="provider-stat-card">

                    <Package size={24} />

                    <div>

                        <span>

                            Food Items

                        </span>

                        <h3>

                            {order.items?.length || 0}

                        </h3>

                    </div>

                </div>

                <div className="provider-stat-card">

                    <IndianRupee size={24} />

                    <div>

                        <span>

                            Provider Earnings

                        </span>

                        <h3>

                            ₹

                            {Number(
                                order.providerEarnings || 0
                            ).toLocaleString("en-IN")}

                        </h3>

                    </div>

                </div>

                <div className="provider-stat-card">

                    <BadgeCheck size={24} />

                    <div>

                        <span>

                            Current Status

                        </span>

                        <h3>

                            {order.status}

                        </h3>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default ProviderTab;